import { formatDate, formatMoney } from './helpers';

export default (data) => {
    const d = {
        totalReceiptCount: data?.totalReceiptCount, // 總單據數量
        currReceiptNumber: data?.currReceiptNumber, // 當前單據序號
        payoo: data?.payoo || '---', // 請款單號
        type: data?.filE_TYP_NAM || '---', // 單據類型
        date: formatDate(data?.foO_DAT) || '---', // 單據日期
        receiptNumber: data?.foo || '---', // 發票號碼
        companyName: data?.companyName || '---', // 賣方公司名稱
        bsn: data?.bsn || '---', // 賣方公司統編
        amt: formatMoney(data?.amt) || '---', // 單據總額
        tax: formatMoney(data?.tax) || '---', // 營業稅
        amtBeforeTax: formatMoney(data.amt - data.tax) || '---', // 銷售額(未稅)
        note: data?.note || '---', // 備註
        base64: data?.base64Url, // base64 檔案內容
        fileUrl: data?.filE_ATT, // 檔案網址
    };

    return d;
};
